import React, { useState } from "react";
import { Container, TextField, Button, Typography, Box, Paper } from "@mui/material";
import {
  FormControl,
  FormLabel,
  Grid2,
} from "@mui/material";
import LanguageSelection from "Components/Common/LanguageSelection";
import { styled } from "@mui/system";
import { useFormik } from "formik";
import * as yup from "yup";
import { sendPasswordReset } from "Services/firebase";
import { forgotPassword } from "Services/service";

const styles = (theme) => ({
  padding: "30px",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  "& .language": {
    display: "flex",
    justifyContent: "end",
  },
  "& .forgotForm": {
    border: `1px solid ${theme.palette.border.blue}`,
    padding: "24px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: "420px",
    margin: "auto",
  },
});

const StyledPaper = styled(Paper)({
  padding: "2rem",
  textAlign: "center",
  maxWidth: "400px",
  margin: "auto",
  marginTop: "5rem",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
});

const ForgotPassword = () => {
  const [forgotData, setForgotData] = useState({
    email: "",
  });
  
  const forgotSchema = yup.object({
    email: yup
      .string()
      .email("Email should be valid.")
      .required("Email is required field."),
  });
  
  const {
    dirty,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
    touched,
  } = useFormik({
    initialValues: forgotData,
    enableReinitialize: true,
    onSubmit: async (data) => {
      console.log("data", data);
      try {
        // const response = await sendPasswordReset(data.email);
        const response = await forgotPassword({Email: data.email})
        console.log('response: ', response);
      } catch (error) {
        console.log('error: ', error);
      }
    },
    validationSchema: forgotSchema,
  });

  return (
    <>
      <Grid2 sx={(theme) => styles(theme)}>
        {/* <Grid2 className="language">
          <LanguageSelection />
        </Grid2> */}
        <form className="forgotForm" onSubmit={handleSubmit}>
          <Typography
            marginBottom={"10px"}
            color="primary"
            variant="title"
            fontWeight={500}
          >
            Forgot Password
          </Typography>
          <FormControl fullWidth>
            <FormLabel color="secondary" required label>
              Email
            </FormLabel>
            <TextField
              error={touched.email && errors.email}
              helperText={touched.email && errors.email && errors.email}
              onChange={handleChange}
              onBlur={handleBlur}
              type="email"
              name="email"
              size="small"
              placeholder="Enter Your Email"
            />
          </FormControl>
          <Button type="submit" sx={{ marginTop: "20px" }} variant="contained" fullWidth size="large">
            Forgot Password
          </Button>
        </form>
      </Grid2>
      {/* <Container>
        <StyledPaper>
          <Typography variant="h5" color="primary" gutterBottom>
            Forgot Password
          </Typography>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            required
          />
          <Box display="flex" alignItems="center" justifyContent="center" my={2}>
            <div className="g-recaptcha" data-sitekey="your-site-key"></div>
          </Box>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            sx={{ mt: 2, backgroundColor: "#FF5C8D" }}
          >
            Reset Password
          </Button>
          <Box mt={2}>
            <Typography variant="body2">
              <a href="/signin" style={{ textDecoration: "none", color: "#1976d2" }}>Sign in</a> | 
              <a href="/signup" style={{ textDecoration: "none", color: "#1976d2", marginLeft: "5px" }}>Sign up</a>
            </Typography>
          </Box>
        </StyledPaper>
      </Container> */}
    </>
  );
};

export default ForgotPassword;